import { Image, Link, makeStyles, Tooltip } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface ISocialMediaButtonProps {
    name: string;
    urL: string;
    logoPath: string;
}

const SocialMediaButton = (props: ISocialMediaButtonProps) => {
    const { name, urL, logoPath } = props;

    return (
        <Tooltip content={name} relationship='label'>
            <Link href={urL} target="_blank">
                <Image loading="lazy" src={logoPath} alt={name} fetchPriority="low" width={48} height={48} />
            </Link>
        </Tooltip>
    );
}

const useStyles = makeStyles({
    socialIcons: {
        display: 'flex',
        gap: '10px',
        marginTop: '10px',
        justifyContent: 'center',

        '@media (min-width: 600px)': {
            justifyContent: 'flex-start',
        }
    }
});

const SocialMedia = () => {
    const { t } = useTranslation("socials");
    const styles = useStyles();

    return (
        <div className={styles.socialIcons}>
            <SocialMediaButton name={t("facebook")} urL="https://www.facebook.com/consultdolphin" logoPath="/img/logos/facebook.svg" />
            <SocialMediaButton name={t("instagram")} urL="https://www.instagram.com/consultdolphin/" logoPath="/img/logos/instagram.svg" />
            <SocialMediaButton name={t("youTube")} urL="https://www.youtube.com/channel/UCJ-QZ5wDRBUvIWUWK_3wWfw" logoPath="/img/logos/youtube.svg" />
            <SocialMediaButton name={t("linkedIn")} urL="https://uk.linkedin.com/company/dolphinitsolutions" logoPath="/img/logos/linkedin.svg" />
        </div>
    );
}

export default SocialMedia;